import { useCallback, useMemo, useRef, useState } from 'react';
import style from './popover.style';
import Portal from './Portal';
import { generateString } from '../../tools/utils';

export default function Popover({ children, title, content }) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleOpen = useCallback((e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  }, []);

  const uuid = useMemo(() => generateString(10), []);

  return (
    <div className={`popover-wrapper`}>
      {isOpen ? (
        <Portal
          wrapperId={`react-portal-popover-container-${uuid}`}
          onClose={handleClose}
          childrenRef={popoverRef}
        >
          <div className="popover" ref={popoverRef}>
            <div className="content">
              <div className="inner">
                {title && <div className="title">{title}</div>}
                <div className="inner-content">{content}</div>
              </div>
            </div>
          </div>
        </Portal>
      ) : null}
      <div
        className="popover-link"
        onClick={(e) => handleOpen(e)}
        id={`react-portal-popover-container-${uuid}`}
      >
        {children}
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
